import React from 'react';
import { Delete, Edit, Lock, LockOpen } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { isAllowed } from 'helpers';
import { Link } from 'react-router-dom';

// Esta función genera las columnas para la tabla de usuarios.
// Recibe como parámetros:
// - intl: Objeto para la internacionalización.
// - updateUser: Función para actualizar los datos de un usuario.
// - deleteUserData: Función para eliminar un usuario.
// - user: Objeto con la información del usuario actual.
export const getColumns = (intl, updateUser, deleteUserData, user, corpId) => [
  {
    field: 'firstname',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.corpusers.grid.colFirstName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'lastname',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.corpusers.grid.colLastName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'role_name',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.corpusers.gird.colRolName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'active',
    headerName: intl.formatMessage({ id: 'app.users.usersList.statusCorp' }),
    renderCell: (rowData) =>
      rowData.row.active === 0
        ? intl.formatMessage({ id: 'app.users.usersList.unlocked' })
        : intl.formatMessage({ id: 'app.users.usersList.locked' }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'tel',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.corpusers.grid.colTel',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'email',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.corpusers.grid.colEmail',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    // Columna de acciones para cada usuario
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    flex: 1,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      const actions = [];
      // Si el usuario tiene permiso para eliminar usuarios
      if (isAllowed(user.permissions, ['user_delete'])) {
        actions.push(
          <Tooltip
            title={intl.formatMessage({
              id: 'app.metusers.grid.colAction.delete',
            })}
          >
            <IconButton
              onClick={() => deleteUserData(params.row)}
              color="error"
              aria-label={intl.formatMessage({
                id: 'app.metusers.grid.colAction.delete',
              })}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        );
      }

      // Si el usuario tiene permiso para actualizar usuarios
      if (isAllowed(user.permissions, ['user_update'])) {
        actions.push(
          <>
            <Link
              to={`/updateAdminUser/${params.row.id}`}
              state={{ user: params.row, corpId: corpId }}
              style={{ textDecoration: 'none' }}
            >
              <Tooltip
                title={intl.formatMessage({
                  id: 'app.metusers.grid.colAction.edit',
                })}
              >
                <IconButton
                  aria-label={intl.formatMessage({
                    id: 'app.metusers.grid.colAction.edit',
                  })}
                  color="secondary"
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            </Link>
            <Tooltip
              // Tooltip que indica si se bloqueará o desbloqueará al usuario
              title={params.row.active === 0 ? 'Bloquear' : 'Desbloquear'}
            >
              <IconButton onClick={() => updateUser(params.row)}>
                {params.row.active === 1 ? <Lock /> : <LockOpen />}
              </IconButton>
            </Tooltip>
          </>
        );
      }
      return actions;
    },
  },
];
